import { CreateAuthorizedShoppingCartRequest } from '../../models/order-capture.model';
import { VoiceProduct } from '@shared/models/voice-product.model';
import { MbbProduct } from '@sales/modules/mbb/models/mbb-product.model';
import { HardwareProduct } from '@shared/models/hardware-product.model';
import { MobilePhoneProduct } from '../../models/mobilephone-product';
import { OrderItem } from '@app/shared/models/order.model';

export class PlaceOrderAction {
  static readonly type = '[Place-order] Start order placement action';
}

export class OrderCaptureResetAction {
  public static readonly type = '[Order-capture] Reset order capture state';
}

export class PlaceOrderResetAction {
  public static readonly type = '[Place-Order] Reset place order state';
}

export class CreateAuthorizedShoppingCartAction {
  static readonly type = '[Shopping-cart] Create authorized shoppingcart action';
  constructor(public request: CreateAuthorizedShoppingCartRequest) {}
}

export class AuthorizedShoppingCartAction {
  static readonly type = '[Shopping-cart] Authorize existing shoppingcart action';
  constructor(public request: CreateAuthorizedShoppingCartRequest) {}
}

export class AddExternalShoppingCartAction {
  static readonly type = '[Shopping-cart] Add new external shoppingcart action';
  constructor(public externalShoppingCartId: string) {}
}

export class AddVoiceProductsAction {
  static readonly type = '[Order-capture] Add voice products action';
}

export class AddHardwareProductsAction {
  static readonly type = '[Order-capture] Add hardware products action';
}

export class AddMobileProductsAction {
  static readonly type = '[Order-capture] Add mobile products action';
}

export class AddReturnBoxAction {
  static readonly type = '[Order-capture] Add return box';
}

export class AddCustomerServiceProductsAction {
  static readonly type = '[Order-capture] Add customer service products action';
}

export class AddTradeInProductAction {
  static readonly type = '[Order-capture] Add trade in product action';
}

export class AddVendorSubsidyVoucherAction {
  static readonly type = '[Order-capture] Add vendor subsidy voucher action';
}

export class AddProductAction {
  static readonly type = '[API] Add product action';
  constructor(
    public offeringId: string,
    public product: VoiceProduct | MbbProduct | HardwareProduct | MobilePhoneProduct
  ) {}
}

export class AddOrderItemAction {
  static readonly type = '[API] Add order item action';
  constructor(public orderItem: OrderItem) {}
}

export class AddMbbProductsAction {
  static readonly type = '[API] Add voice products action';
}

export class CreateOrderRequestCompletedAction {
  static readonly type = '[Order-capture] Order capture completed';
}

export class GenerateContractDataAction {
  static readonly type = '[Order-capture] Generate contract data';
}
